import React from 'react';
import styled from 'styled-components';

import { mediaQueries } from 'shared/styles';
import { Logo } from 'shared/assets/logo';
import { BaseSlideWrapper, BaseSlideContent, BaseSlideCta, BaseSlideImage } from './login.styles';

export const Winter25 = (): JSX.Element => (
  <Wrapper>
    <Logo fill='#F0E7D4' />
    <Content>
      <SubHeading>Coming soon:</SubHeading>

      <Heading>
        Connect & Nexus,
        <br />
        powered by
        <br />
        Dutchie Intelligence
      </Heading>

      <Cta
        href='https://business.dutchie.com/connect-nexus-video-teaser?utm_source=ecomm&utm_medium=banner&utm_campaign=connexuslaunch25'
        target='_blank'
        rel='noreferrer'
      >
        See it in action
      </Cta>

      <Images>
        <BaseSlideImage
          src='https://images.dutchie.com/admin-login/winter-25/connect-nexus.png'
          alt='Screenshots of new features'
          width={685}
        />

        <BaseSlideImage
          src='https://images.dutchie.com/admin-login/winter-25/intelligence.png'
          alt='Screenshots of new features'
          width={685}
        />
      </Images>
    </Content>
  </Wrapper>
);

const Wrapper = styled(BaseSlideWrapper)`
  background: #005943 url('https://images.dutchie.com/admin-login/winter-25/background.png') no-repeat center/cover;
  padding-top: 58px;
`;

const Content = styled(BaseSlideContent)`
  color: #f0e7d4;
  padding-top: 66px;
`;

const SubHeading = styled.h2`
  font-size: 32px;
`;

const Heading = styled.h1`
  color: #f0e7d4;
  text-align: center;
  font-family: Matter;
  font-size: 60px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  @media ${mediaQueries.belowMedium} {
    font-size: 48px;
  }
`;

const Cta = styled(BaseSlideCta)`
  margin-top: 48px;
  background: #ffc02a;
  color: #062f22;

  &:hover {
    background: none;
    box-shadow: inset 0 0 0 2px #fff7ef;
    color: #fff7ef;
  }
`;

const Images = styled.div`
  margin-top: 68px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
